import script from "./UserSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSignup.vue?vue&type=script&setup=true&lang=js"

import "./UserSignup.vue?vue&type=style&index=0&id=1b91ecf0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/API-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b91ecf0"]])

export default __exports__